module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0",
    class: _vm.setting.class,
    attrs: {
      "id": _vm.setting.id
    }
  }, [_c('div', {
    staticClass: "j-mutiple-left"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "from",
      "id": "multiselect",
      "size": "8",
      "multiple": "multiple"
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.setting.options), function(option, index) {
    return _c('option', {
      class: 'o-' + option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-middle"
  }, [_c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_rightAll-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-forward"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_rightSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_leftSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_leftAll-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-backward"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-right"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "to",
      "id": 'multiselect_to-' + _vm.setting.class,
      "size": "8",
      "multiple": "multiple"
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(_vm.setting.choose.length) + " 間")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2f82b12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/jMutiSelect.vue
// module id = 2558
// module chunks = 1